import React from "react";
import RouteObject from "react-router-dom";
import ProductLayout from "../../layout/ProductLayout/ProductLayout";
import AllProducts from "../../pages/LADProducts/AllProductList/AllProducts";
import AddProduct from "../../pages/LADProducts/AddProducts/AddProduct";
import CategoryManagement from "../../pages/LADProducts/CategoryMgt/CategoryManagement";
import HsnManagement from "../../pages/LADProducts/HSNMgt/HsnManagement";
import UnitSettings from "../../pages/LADProducts/UnitSettings/ServiceUnitSettings";
import RelatedProductSettings from "../../pages/LADProducts/RelatedProductSettings/RelatedProductSettings";
import ViewProduct from "../../pages/LADProducts/ViewProduct/ViewProduct";
import SingleRfqView from "../../components/modals/ProductModals/AllProductModals/Rfq Modals/SingleRfqView";
import Trash from "../../pages/LADProducts/Trash/Trash";
import Add_Produc_Edit from "../../pages/LADProducts/AddProducts/SubComponents/Add_Product_Edit_save/Add_Produc_Save";
import Add_Product_Edit_Layout from "../../pages/LADProducts/AddProducts/SubComponents/Add_Product_Edit_save/Add_Product_Edit_Layout";
import Add_Product_Save from "../../pages/LADProducts/AddProducts/SubComponents/Add_Product_Edit_save/Add_Product_Edit";

const ProductsRoutes: RouteObject[] = [
  {
    path: "product-module",
    element: <ProductLayout />,
    children: [
      {
        // Default route for product-module
        index: true,
        element: <AllProducts />,
      },
      {
        path: "all-products",
        element: <AllProducts />,
      },
      {
        path: "add-products",
        element: <AddProduct />,
      },
      {
        path: "category-management",
        element: <CategoryManagement />,
      },
      {
        path: "hsn-management",
        element: <HsnManagement />,
        },
      {
        path: "unit-settings",
        element: <UnitSettings />,
      },
      {
        path: "related-product-settings",
        element: <RelatedProductSettings />,
      },
      {
        path: "product-trash",
        element: <Trash />,
      },
      {
        path: "view-product/:id",
        element: <ViewProduct />,
       },
      {
        path: "view-Rfq/:id",
        element: <SingleRfqView />,
      },
    ],
  },
  {
    path: "save-product",
    element: <Add_Product_Edit_Layout />,
    children: [
      {
        index: true,
        element: <Add_Product_Save />,
      },
      {
        path: "edit-product",
        element: <Add_Produc_Edit />,
      },
    ],
  },
];

export default ProductsRoutes;
